import React from "react";
import {observer} from "mobx-react";
import PropTypes from "prop-types";
import useOnNavigate from "../hooks/use-on-navigate";
import useRouter from "../hooks/use-router";

function WhenRouteHasParameter(props) {

    const router = useRouter();

    function checkIfShouldRender() {

        const parameter = router.parameter(props.name);

        const toMatch = props.matches;

        if(typeof toMatch === "undefined") {
            return parameter !== null;
        }

        if(parameter === toMatch) {
            return true;
        }

        if(`${parameter}` === `${toMatch}`) {
            return true;
        }

        return false;
    }

    const [shouldRender, setShouldRender] = React.useState(checkIfShouldRender());

    useOnNavigate(() => {
        setShouldRender(checkIfShouldRender());
    });

    const negate = props.negate || false;

    return (shouldRender !== negate) ? props.children : null;
}

WhenRouteHasParameter.propTypes = {
    /**
     * The parameter name to match the current route against.
     */
    name: PropTypes.string.isRequired,
    /**
     * The value to match the current parameter against.
     */
    matches: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /**
     * Should the result be negated?
     */
    negate: PropTypes.bool,
}

export default observer(WhenRouteHasParameter)

